export const STARS_NUMBER = 5;
